export const spotifyCredentials = {
    clientId: process.env.VUE_APP_SPOTIFY_CLIENT_ID,
    clientSecret: process.env.VUE_APP_SPOTIFY_CLIENT_SECRET,
    redirectUri: process.env.VUE_APP_BASE_URL + "/authorize",
    scopes: process.env.VUE_APP_SCOPES.split(","),
} as {
    clientId: string;
    clientSecret: string;
    redirectUri: string;
    scopes: string[];
};
